import { Injectable } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { Store } from '@ngrx/store';
import { MaintenanceScheduleState } from './maintenance-schedule.interfaces';
import * as fromMaintenanceSchedule from './maintenance-schedule.actions';
// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleQueryParameters } from '@quorum/models/xs-query';
@Injectable()
export class MaintenanceScheduleStateService {
  constructor(private store: Store<MaintenanceScheduleState>) {}

  getMaintenanceSchedules(params: VehicleMaintenanceScheduleQueryParameters) {
    this.store.dispatch(new fromMaintenanceSchedule.GetMaintenanceSchedulesFromServer(params));
  }
}
